<template>
  <div class="combo-form">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="10">
          <div class="form-group row header-custom-switch">
            <legend class="col-sm-12 col-form-label uppercase">
              <strong>
                <h3>
                  <router-link :to="{ name: 'combo_list'}" class="float-left mr-1 main-link">{{$t('combo.combos')}}
                  </router-link>
                  <span class="float-left mr-1 main-link">/</span>
                  <router-link :to="{ name: 'combo_edit',  params: { uuid: item.combo_uuid }}"
                               class="float-left mr-1 main-link">{{$t('combo.detail')}}
                  </router-link>
                  / {{$t('combo.group_information')}}
                </h3>
              </strong>
            </legend>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <b-card footer-tag="footer">
            <div class="group-header">
              <b-form-checkbox-group id="checkbox-group-2" v-model="deleteGroups" name="flavour-2">
                <div :class="'group-item' + (active_group_uuid == groupHeader.uuid ? ' active' : '')"
                     v-for="groupHeader in item.groups" :key="groupHeader.uuid">
                  <div class="group-checkbox" v-if="groupHeader.newGroup != 1">
                    <b-form-checkbox :value="groupHeader.uuid">
                    </b-form-checkbox>
                  </div>
                  <div class="group-name" v-on:click="updateActiveGroupUuid(groupHeader.uuid)">
                    <span v-if="active_group_uuid != groupHeader.uuid">{{groupHeader.name[$session.get('lang')]}}</span>
                    <span v-else>{{group.name[$session.get('lang')]}}</span>
                  </div>
                </div>
                <div class="group-item bg-main" v-on:click="addComboGroup()">
                  <div class="group-name">
                    <i class="fa fa-plus"></i> {{$t('common.new')}}
                  </div>
                </div>
                <div :class="'group-item float-right bg-danger border-radius-4px' + (deleteGroups.length > 0 ? '' : ' ')" v-on:click="deleteComboGroups()">
                  <div class="group-name">
                    <i class="fa fa-trash-o float-left mt-1"></i> {{$t('common.delete')}} <span v-if="deleteGroups.length > 0">({{deleteGroups.length}})</span>
                  </div>
                </div>
              </b-form-checkbox-group>
            </div>
            <div class="group-body">
              <b-row class="form-group">
                <b-col cols="6">
                  <b-form-group v-bind:label="$t('combo.group_id')" :label-cols="3" :horizontal="true">
                    <b-form-input type="text" disabled="disabled" class="form-control border-radius-4px" v-model="group.id"/>
                  </b-form-group>
                </b-col>
              </b-row>
              <b-row class="form-group">
                
                <b-col cols="6">
                  <div class="form-row">
                    <legend class="col-sm-3 col-form-label ">{{$t('combo.marketing_name')}}</legend>
                    <div v-for="(lang, lidx) in $store.getters.languages" class="col-sm-9" :key="lang.id" v-if="lidx == 0">
                      <b-form-input type="text"
                                    :name="`name[${lang}]`"
                                    class="form-control border-radius-4px"
                                    v-model="group.name[lang]"
                                    v-bind:placeholder="$t('common.text_' + lang)"
                      />
                    </div>
                  </div>
                </b-col>
                <b-col cols="6">
                  <div class="form-row">
                    <div v-for="(lang,lidx) in $store.getters.languages" class="col-sm-9" :key="lang.id" v-if="lidx > 0">
                      <b-form-input type="text"
                                    :name="`name[${lang}]`"
                                    class="form-control border-radius-4px"
                                    v-model="group.name[lang]"
                                    v-bind:placeholder="$t('common.text_' + lang)"
                      />
                    </div>
                    <b-col cols="3" class="form-row">
                      <b-button variant="primary" class="border-radius-4px bg-main col-sm-10" v-on:click="addItem()"
                                v-show="combo.config.more_item">
                        <i class="fa fa-plus"></i>&nbsp;
                        {{$t('combo.menu_item')}}
                      </b-button>
                    </b-col>
                  </div>
                </b-col>
              </b-row>
              <!-- Basic information -->
              <b-row>
                <b-col cols="6">
                  <input type="hidden" name="combo_id" :value="item.combo_id">
                  <b-form-group v-bind:label="$t('combo.name_seo')" :label-cols="3" :horizontal="true">
                    <b-form-input
                      type="text"
                      class="form-control border-radius-4px "
                      v-model="group.name_seo"
                    />
                  </b-form-group>

                  <b-form-group v-bind:label="$t('combo.min_group')" :label-cols="3" :horizontal="true">
                    <b-form-input
                      type="number"
                      class="form-control border-radius-4px"
                      v-model="group.min"
                      min="0" max="99"/>
                  </b-form-group>

                  <b-form-group v-bind:label="$t('combo.max_group')" :label-cols="3" :horizontal="true">
                    <b-form-input
                      type="number"
                      class="form-control border-radius-4px "
                      v-model="group.max"
                      min="0" max="99"/>
                  </b-form-group>

                  <b-form-group v-bind:label="$t('combo.sequence')" :label-cols="3" :horizontal="true">
                    <b-form-input
                      type="number"
                      class="form-control border-radius-4px "
                      v-model="group.sequence"/>
                  </b-form-group>

                  <b-form-group v-bind:label="$t('combo.show_ui')" :label-cols="3" :horizontal="true" class="hide">
                    <c-switch type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true"
                              v-model="group.active" :value="1" :uncheckedValue="0"/>
                  </b-form-group>

                  <b-form-group v-bind:label="$t('combo.half_half')" :label-cols="3" :horizontal="true">
                    <c-switch type="icon" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}" :pill="true"
                              v-model="group.has_half_half" :value="1" :uncheckedValue="0"/>
                  </b-form-group>

                </b-col>
                <!-- Images -->
                <b-col cols="6" class="hide">
                  <b-row>
                    <b-col cols="4" v-for="(data, image) in group.imageData" :key="data.id">
                      <b-form-group v-bind:label="$t(image)">
                        <b-form-file v-model="group.imageData[image]" :id="image"
                                     @change="previewImageComboGroup($event)" accept="image/*"></b-form-file>
                      </b-form-group>
                      <div v-bind:class="'image-' + image + '-preview img-min-height'">
                        <img class="preview-image" v-bind:src="data">
                      </div>
                      <hr/>
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
              <!-- item information -->
              <draggable :disabled="!enabled" class="list-group" ghost-class="ghost" v-model="group.items" group="pizza" draggable=".item" @change="checkMoveItems" @start="isDragging=true" @end="isDragging=false">
                <b-row v-for="(itemGroup, i) in group.items" :key="itemGroup.uuid +'-' + itemGroup.sequence" :id="itemGroup.uuid +'-' + itemGroup.sequence" :class=" groupItemShow[i] ? '':'item' + ' list-item'">
                  <b-col cols="12">
                    <b-card class="menu-item-content border-none">
                      <!-- select menu item to add into combo group -->
                      <div slot="header">
                        <div class="d-flex align-items-center w-100">
                          <div class="d-flex d-flex align-items-center">
                            <span class="mr-2">{{$t('combo.menu_item')}}</span>
                            <multiselect class="mr-2" style="width: 800px" v-model="menuItemSelected[i]" label="text"
                                        track-by="text" :options="menuItems[$session.get('lang')]"
                                        @input="changeMenuItem(i)"
                                        :hideSelected="true"
                                        :show-labels="false">
                              <template v-if="props.option.value.length > 0" slot="singleLabel" slot-scope="props">
                                <span>{{props.option.text}}</span>
                              </template>
                              <template v-if="props.option.value.length > 0" slot="option" slot-scope="props"><span>{{props.option.name}} | <span
                                style="color: #6200EE">{{props.option.sku}}</span></span>
                                <div class="option__desc">
                                  <span style="font-size: 10px; color: #424242" class="option__small"
                                        v-if="props.option.value.length > 0">
                                            {{'Selling start: ' + props.option.selling_start + ' - ' + props.option.selling_end}}
                                      </span></div>
                              </template>
                            </multiselect>
                            <div class="ml-2 copy-section">
                              <i class="fa fa-files-o pointer" @click="copySku(i)"></i>
                            </div>
                          </div>
                          <div class="d-flex align-items-center ml-auto">
                            <legend v-if="combo.config.set_default" class="mr-2 col-form-label">{{$t('combo.set_default')}}</legend>
                            <div class="mr-2" v-if="combo.config.set_default">
                              <c-switch type="icon" class="switch-customize" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                        :pill="true" v-model="itemGroup.default" :value="1"
                                        @change="setDefault('menu', {itemIndex: i})"
                                        :uncheckedValue="0"/>
                              
                            </div>

                            <div class="remove-section mr-2">
                              <i class="fa fa-trash-o pointer" @click="removeItem(i)"
                                v-show="combo.config.more_item"></i>
                            </div>
                            <div class="mr-2">
                              <button type="button" class="btn btn-md border-radius-4px bg-main btn-primary" @click="updateGroupItemShow($event,i)">
                                <i class="fa fa-angle-up" v-if="groupItemShow[i]"></i>
                                <i class="fa fa-angle-down" v-if="!groupItemShow[i]"></i>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <b-collapse v-model="groupItemShow[i]" :id="'combo-group-item-' + i">
                        <!-- opening hours and special date -->
                        <b-row v-if="menuItemSelected[i] && combo.config.opening_hours">
                          <b-col cols="4">
                            <h4 class="title">{{$t('combo.available')}}</h4>
                          </b-col>
                        </b-row>

                        <!-- Part of Days of Week -->
                        <b-row v-if="menuItemSelected[i]">
                          <b-col cols="4" v-if="combo.config.opening_hours">
                            <b-form-group :label-cols="3" :horizontal="true" v-for="day in daysOfWeek" :key="day.id"
                                          v-bind:label="$t(day)">
                              <div role="group" class="input-group">
                                <!-- debug here -->
                                <div class="input-group-append">
                                  <div class="input-group-text">
                                    <b-form-checkbox v-model="itemGroup.opening_times[day].active" :value="1"
                                                    :unchecked-value="0"></b-form-checkbox>
                                  </div>
                                </div>
                                <masked-input
                                  type="text"
                                  name="date"
                                  class="form-control col-sm-6 float-left"
                                  v-model="itemGroup.opening_times[day].opening"
                                  :mask="[/\d/, /\d/, ':', /\d/, /\d/, ':', '0', '0']"
                                  :guide="true"
                                  placeholderChar="_"
                                  :showMask="true"
                                  :keepCharPositions="true">
                                </masked-input>
                                <div class="input-group-append">
                                  <div class="input-group-text"><i class="fa fa-minus"></i></div>
                                </div>
                                <masked-input
                                  type="text"
                                  name="date"
                                  class="form-control col-sm-6 float-left"
                                  v-model="itemGroup.opening_times[day].closing"
                                  :mask="[/\d/, /\d/, ':', /\d/, /\d/, ':', '0', '0']"
                                  :guide="true"
                                  placeholderChar="_"
                                  :showMask="true"
                                  :keepCharPositions="true">
                                </masked-input>
                              </div>
                            </b-form-group>
                          </b-col>
                          <!-- End of Days of Week -->

                          <!-- Part of Special Date -->
                          <b-col cols="8" v-if="false">
                            <b-form-group :label-cols="11" v-bind:label="$t('combo.special_date')">
                              <table class="table table-bordered table-hover">
                                <thead>
                                <tr>
                                  <th>{{$t('combo.name')}}</th>
                                  <th>{{$t('combo.date')}}</th>
                                  <th>{{$t('combo.time')}}</th>
                                  <th>{{$t('combo.open')}}</th>
                                  <th>{{$t('combo.active')}}</th>
                                  <th>{{$t('combo.action')}}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="(date, index) in itemGroup.special_dates" :key="date.id">
                                  <td>
                                    <b-form-input class="form-control" v-model="itemGroup.special_dates[index].name">
                                    </b-form-input>
                                  </td>
                                  <td>
                                    <masked-input
                                      type="text"
                                      name="date"
                                      class="form-control"
                                      v-model="itemGroup.special_dates[index].date"
                                      :mask="[/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/]"
                                      :guide="true"
                                      placeholderChar="_"
                                      :showMask="true"
                                      :keepCharPositions="true">
                                    </masked-input>
                                  </td>
                                  <td>
                                    <div role="group" class="input-group">
                                      <masked-input
                                        type="text"
                                        name="date"
                                        class="form-control col-sm-6 float-left"
                                        v-model="itemGroup.special_dates[index].from"
                                        :mask="[/\d/, /\d/, ':', /\d/, /\d/, ':', '0', '0']"
                                        :guide="true"
                                        placeholderChar="_"
                                        :showMask="true"
                                        :keepCharPositions="true">
                                      </masked-input>
                                      <div class="input-group-append">
                                        <div class="input-group-text"><i class="fa fa-minus"></i></div>
                                      </div>
                                      <masked-input
                                        type="text"
                                        name="date"
                                        class="form-control col-sm-6 float-left"
                                        v-model="itemGroup.special_dates[index].to"
                                        :mask="[/\d/, /\d/, ':', /\d/, /\d/, ':', '0', '0']"
                                        :guide="true"
                                        placeholderChar="_"
                                        :showMask="true"
                                        :keepCharPositions="true">
                                      </masked-input>
                                    </div>
                                  </td>
                                  <td>
                                    <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                              :pill="true" v-model="itemGroup.special_dates[index].status"
                                              :checked="itemGroup.special_dates[index].status" :value="1"
                                              :uncheckedValue="0"/>
                                  </td>
                                  <td>
                                    <c-switch type="icon" variant="success" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                              :pill="true" v-model="itemGroup.special_dates[index].active"
                                              :checked="itemGroup.special_dates[index].active" :value="1"
                                              :uncheckedValue="0"/>
                                  </td>
                                  <td>
                                    <b-button variant="danger" v-on:click="removeSpecialDate(i, index)" size="sm"
                                              v-show="combo.config.special_date"><i class="fa fa-trash-o"></i></b-button>
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="6">
                                    <b-button variant="success" v-on:click="addSpecialDate(i)"
                                              v-show="combo.config.special_date"><i class="fa fa-plus"></i></b-button>
                                  </td>
                                </tr>
                                </tbody>
                              </table>
                            </b-form-group>
                          </b-col>
                          <!-- End of Special Date -->
                        </b-row>
                        <!-- Part of Single Layers -->

                        <!-- Part of Single Price -->
                        <b-row v-if="menuItemSelected[i] && combo.config.single_price">
                          <div class="col-sm-2">{{$t('combo.price')}}({{currency.symbol}})</div>
                          <div class="size-price-input col-sm-10"
                              v-if="_.size(tier) <= 1 && combo.config.single_multi_price != true && combo.config.product_tax_price != true">
                            <div class="full-width" v-for="(price, p) in itemGroup.prices" :key="price.id">
                              <input type="hidden" class="form-control" v-model="itemGroup.prices[p].active"/>
                              <input type="hidden" class="form-control" v-model="itemGroup.prices[p].from"/>
                              <input type="hidden" class="form-control" v-model="itemGroup.prices[p].to"/>
                              <input type="hidden" class="form-control" v-model="itemGroup.prices[p].tax_rate"/>
                              <div v-for="(name, index) in tier" class="full-width">
                                <b-form-input type="number" min="0" class="form-control border-radius-4px"
                                              v-model="itemGroup.prices[p].price[index]"
                                              v-bind:placeholder="$t('combo.price')"
                                              :disabled="checkDisableByConfig('single', 'price')">
                                </b-form-input>
                                <input type="hidden" class="form-control"
                                      v-model="itemGroup.prices[p].price_without_tax[index]"/>
                              </div>
                            </div>
                          </div>
                          <div class="size-price-input col-sm-10"
                              v-if="_.size(tier) > 1 ||  combo.config.single_multi_price == true || combo.config.product_tax_price == true">
                            <button type="button" class="btn bg-main border-radius-4px" v-on:click="showModal('menu_'+i)">
                              {{$t('combo.edit_price')}}
                            </button>
                            <!-- the prices modal -->
                            <b-modal :id="'menu_'+i" centered :title="$t('combo.item_price')+ '('+currency.symbol+')'">
                              <div class="row" v-if="combo.config.single_multi_price">
                                <div class="col-sm-12 mb-2 text-main">
                                  <span class="button-text" @click="addPriceToSingle(i)"><i class="fa fa-plus"></i> {{$t('common.add')}}</span>
                                </div>
                              </div>

                              <div class="full-width" v-for="(price, p) in itemGroup.prices" :key="price.id">
                                <input type="hidden" class="form-control" v-model="itemGroup.prices[p].active"/>
                                <div class="row bg-secondary py-2 d-flex" v-if="combo.config.single_multi_price">
                                  <div class="d-flex flex-1 px-3">
                                    <div class="size-label">{{$t('combo.from')}}</div>
                                    <div class="size-code-input">
                                      <masked-input
                                        type="text"
                                        name="date"
                                        class="form-control border-radius-4px"
                                        v-model="itemGroup.prices[p].from"
                                        :mask="[/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/]"
                                        :guide="true"
                                        placeholderChar="_"
                                        :showMask="true"
                                        :keepCharPositions="true">
                                      </masked-input>
                                    </div>
                                  </div>
                                  <div class="d-flex flex-1 px-3">
                                    <div class="size-label text-right">{{$t('combo.to')}}</div>
                                    <div class="size-code-input ">
                                      <masked-input
                                        type="text"
                                        name="date"
                                        class="form-control border-radius-4px"
                                        v-model="itemGroup.prices[p].to"
                                        :mask="[/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/]"
                                        :guide="true"
                                        placeholderChar="_"
                                        :showMask="true"
                                        :keepCharPositions="true">
                                      </masked-input>
                                    </div>
                                  </div>
                                  <div class="auto-width px-3 button-text remove-section">
                                    <i class="fa fa-trash-o text-main" @click="removePriceToSingle(i, p)"></i>
                                  </div>
                                </div>
                                <div class="row py-2">
                                  <div class="col-sm-12" v-if="combo.config.product_tax_price">
                                    <b-form-group v-bind:label="$t('combo.tax_rate')">
                                      <input type="number" class="form-control" v-model="itemGroup.prices[p].tax_rate"/>
                                    </b-form-group>
                                  </div>
                                  <div class="col-sm-6 d-flex mb-0" v-for="(name, index) in tier">
                                    <b-card class="w-100 pb-0" v-bind:title="name ? name : $t('combo.tier') + ' ' + index">
                                      <b-form-group>
                                        <b-row>
                                          <div class="col-sm-12">
                                            <b-form-group v-bind:label="$t('combo.price')">
                                              <b-form-input type="number" min="0" class="form-control border-radius-4px"
                                                    v-model="itemGroup.prices[p].price[index]"
                                                    v-bind:placeholder="$t('combo.price')"
                                                    :disabled="checkDisableByConfig('single', 'price')">
                                              </b-form-input>
                                            </b-form-group>
                                          </div>
                                          <div class="col-sm-12" v-if="combo.config.product_tax_price">
                                            <b-form-group v-bind:label="$t('combo.price_without_tax')">
                                              <input type="number" class="form-control"
                                                v-model="itemGroup.prices[p].price_without_tax[index]"/>
                                            </b-form-group>
                                          </div>

                                        </b-row>
                                      </b-form-group>
                                    </b-card>
                                  </div>
                                </div>
                              </div>
                              <div slot="modal-footer" class="full-width">
                                <button type="button" class="btn bg-main float-right border-radius-4px"
                                        v-on:click="hideModal('menu_'+i)">{{$t('common.save')}}
                                </button>
                              </div>
                            </b-modal>
                          </div>
                          <!-- End of Single Price -->
                        </b-row>

                        <!-- select crush item to add into combo group -->
                        <b-row v-if="menuItemSelected[i]">
                          <div class="col-sm-2"> {{ $t('combo.crust_size') }}</div>
                          <div class="col-sm-10">
                                  <span class="btn text-main add-more-size" @click="addSingleFirst(i)"
                                        v-show="combo.config.more_first">
                                    <i class="fa fa-plus-circle"></i> {{$t('common.add_more')}}
                                  </span>
                          </div>
                          <b-form class="col-sm-12">
                            <draggable :disabled="!enabled" class="list-group" ghost-class="ghost" v-model="itemGroup.first_layers" :group="{name: 'combo-pizza-first', put: true, pull: false}" draggable=".list-item-first" @start="isDragging=true" @end="isDragging=false">
                              <div class="option-box " :class="groupSizeShow[i + '-' + f] ? '' : 'list-item-first'" v-for="(first, f) in itemGroup.first_layers" :key="first.uuid">
                                <div class="option-first">
                                  <b-row>
                                    <b-col cols="3" class="d-flex">
                                      <div class="size-label">{{$t('combo.size')}}</div>
                                      <div v-for="lang in $store.getters.languages" :key="lang.id" class="size-name-input">
                                        <b-form-input autocomplete="off" :list="'name_first_layer_list_' +lang + '_' + f"
                                                      type="text" class="form-control border-radius-4px"
                                                      @change="updateFirstLayerItems(i, f, $event, lang)"
                                                      v-model="itemGroup.first_layers[f].name[lang]"
                                                      v-bind:placeholder="$t('common.text_'+lang)"></b-form-input>
                                        <datalist :id="'name_first_layer_list_' + lang + '_' + f"
                                                  v-if="first_layer_options.length > 0">
                                          <option v-for="(first_option, i) in first_layer_options" :key="first_option.sku + i"
                                                  v-bind:value="first_option.name[lang]"
                                                  v-bind:label="first_option.name[lang]"></option>
                                        </datalist>
                                      </div>
                                    </b-col>

                                    <b-col cols="2" class="d-flex">
                                      <div class="size-label">{{$t('combo.code')}}</div>
                                      <div class="size-code-input">
                                        <b-form-input autocomplete="off" :list="'sku_first_layer_list_'+ '_' + f"
                                                      type="text" class="form-control border-radius-4px"
                                                      @change="updateFirstLayerItems(i, f, $event, null)"
                                                      v-model="itemGroup.first_layers[f].sku"/>
                                        <datalist :id="'sku_first_layer_list_'+  '_' + f"
                                                  v-if="first_layer_options.length > 0">
                                          <option v-for="(first_option, i) in first_layer_options" :key="first_option.sku + i"
                                                  v-bind:value="first_option.sku" v-bind:label="first_option.sku"></option>
                                        </datalist>
                                      </div>
                                    </b-col>
                                    <b-col cols="2" class="d-flex" v-if="combo.config.first_price">
                                      <div class="size-label"
                                          v-if="_.size(tier) <= 1 && combo.config.single_multi_price != true">
                                        {{$t('combo.price')}} ({{currency.symbol}})
                                      </div>
                                      <div class="size-price-input"
                                          v-if="_.size(tier) <= 1 && combo.config.first_multi_price != true && combo.config.product_tax_price != true">
                                        <div class="full-width" v-for="(price, p) in itemGroup.first_layers[f].prices"
                                            :key="price.id">
                                          <input type="hidden" class="form-control"
                                                v-model="itemGroup.first_layers[f].prices[p].active"/>
                                          <input type="hidden" class="form-control"
                                                v-model="itemGroup.first_layers[f].prices[p].from"/>
                                          <input type="hidden" class="form-control"
                                                v-model="itemGroup.first_layers[f].prices[p].to"/>
                                          <input type="hidden" class="form-control"
                                                v-model="itemGroup.first_layers[f].prices[p].tax_rate"/>
                                          <div v-for="(name, index) in tier" class="full-width">
                                            <b-form-input type="number" min="0" class="form-control border-radius-4px"
                                                          v-model="itemGroup.first_layers[f].prices[p].price[index]"
                                                          v-bind:placeholder="$t('combo.price')"
                                                          :disabled="checkDisableByConfig('first', 'price')">
                                            </b-form-input>
                                            <input type="hidden" class="form-control"
                                                  v-model="itemGroup.first_layers[f].prices[p].price_without_tax[index]"/>
                                          </div>
                                        </div>
                                      </div>
                                      <div class="size-price-input"
                                          v-if="_.size(tier) > 1 || combo.config.first_multi_price == true || combo.config.product_tax_price == true">
                                        <button type="button" class="btn bg-main border-radius-4px"
                                                v-on:click="showModal('first_'+i+'_'+f)">
                                          {{$t('combo.edit_price')}}
                                        </button>
                                        <!-- the prices modal -->
                                        <b-modal :id="'first_'+i+'_'+f" centered
                                                :title="$t('combo.size_price')+'('+currency.symbol+')'">
                                          <div class="row" v-if="combo.config.first_multi_price">
                                            <div class="col-sm-12 mb-2 text-main">
                                              <span class="button-text" @click="addPriceToSingleFirst(i,f)"><i
                                                class="fa fa-plus"></i> {{$t('common.add')}}</span>
                                            </div>
                                          </div>
                                          <div class="full-width" v-for="(price, p) in itemGroup.first_layers[f].prices"
                                              :key="price.id">
                                            <input type="hidden" class="form-control"
                                                  v-model="itemGroup.first_layers[f].prices[p].active"/>
                                            <div class="row bg-secondary py-2 d-flex" v-if="combo.config.first_multi_price">
                                              <div class="d-flex flex-1 px-3">
                                                <div class="size-label">{{$t('combo.from')}}</div>
                                                <div class="size-code-input">
                                                  <masked-input
                                                    type="text"
                                                    name="date"
                                                    class="form-control border-radius-4px"
                                                    v-model="itemGroup.first_layers[f].prices[p].from"
                                                    :mask="[/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/]"
                                                    :guide="true"
                                                    placeholderChar="_"
                                                    :showMask="true"
                                                    :keepCharPositions="true">
                                                  </masked-input>
                                                </div>
                                              </div>
                                              <div class="d-flex flex-1 px-3">
                                                <div class="size-label text-right">{{$t('combo.to')}}</div>
                                                <div class="size-code-input">
                                                  <masked-input
                                                    type="text"
                                                    name="date"
                                                    class="form-control border-radius-4px"
                                                    v-model="itemGroup.first_layers[f].prices[p].to"
                                                    :mask="[/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/]"
                                                    :guide="true"
                                                    placeholderChar="_"
                                                    :showMask="true"
                                                    :keepCharPositions="true">
                                                  </masked-input>
                                                </div>
                                              </div>
                                              <div class="auto-width px-3 button-text remove-section">
                                                <i class="fa fa-trash-o text-main"
                                                  @click="removePriceToSingleFirst(i, f, p)"></i>
                                              </div>
                                            </div>
                                            <div class="row py-2">
                                              <div class="col-sm-12" v-if="combo.config.product_tax_price">
                                                <b-form-group v-bind:label="$t('combo.tax_rate')">
                                                  <input type="number" class="form-control"
                                                    v-model="itemGroup.first_layers[f].prices[p].tax_rate"/>
                                                </b-form-group>
                                              </div>
                                              <div class="col-sm-6 d-flex mb-0" v-for="(name, index) in tier">
                                                <b-card class="w-100 pb-0" v-bind:title="name ? name : $t('combo.tier') + ' ' + index">
                                                  <b-form-group>
                                                    <b-row>
                                                      <div class="col-sm-12">
                                                        <b-form-group v-bind:label="$t('combo.price')">
                                                          <b-form-input type="number" min="0" class="form-control border-radius-4px"
                                                                v-model="itemGroup.first_layers[f].prices[p].price[index]"
                                                                v-bind:placeholder="$t('combo.price')"
                                                                :disabled="checkDisableByConfig('first', 'price')">
                                                          </b-form-input>
                                                        </b-form-group>
                                                      </div>
                                                      <div class="col-sm-12" v-if="combo.config.product_tax_price">
                                                        <b-form-group v-bind:label="$t('combo.price_without_tax')">
                                                          <input type="number" class="form-control"
                                                            v-model="itemGroup.first_layers[f].prices[p].price_without_tax[index]"/>
                                                        </b-form-group>
                                                      </div>
                                                    </b-row>
                                                  </b-form-group>
                                                </b-card>
                                              </div>
                                            </div>
                                          </div>
                                          <div slot="modal-footer" class="full-width">
                                            <button type="button" class="btn bg-main float-right border-radius-4px"
                                                    v-on:click="hideModal('first_'+i+'_'+f)">{{$t('common.save')}}
                                            </button>
                                          </div>
                                        </b-modal>
                                      </div>
                                    </b-col>
                                    <b-col cols="5" class="d-flex justify-content-end w-100">
                                      <div class="d-flex align-items-center justify-content-end pl-2 pr-2">
                                        <div v-if="combo.config.set_default && itemGroup.default" :class="`d-flex align-items-center pl-2 pr-2 ${combo.config.set_default && itemGroup.default && !objDefault.first ? 'br-color-default' : ''}`">
                                          <legend class="mr-default col-form-label mr-2">{{$t('combo.set_default')}}</legend>
                                          <div>
                                            <c-switch-custom type="icon" class="switch-customize" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                                    :pill="true" v-model="itemGroup.first_layers[f].default" :value="1"
                                                    :disabled="itemGroup.first_layers[f].active ? false : true "
                                                    @change="setDefault('first', {itemIndex: i, firstIndex: f} )"
                                                    :uncheckedValue="0"/>
                                          </div>
                                        </div>
                                        <span class="ml-3 mr-2">{{$t('combo.active')}}</span>
                                        <div class="mr-3">
                                          <c-switch type="icon" class="switch-customize" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                                  :pill="true" v-model="itemGroup.first_layers[f].active" :value="1"
                                                  :key="'witch-customize-fist-layers-'+i+'-'+f+'-'+key"
                                                  @change="inActive('first', {itemIndex: i, firstIndex: f, active: itemGroup.first_layers[f].active})"
                                                  :uncheckedValue="0"/>
                                        </div>
                                        <i class="fa fa-trash-o text-main pointer float-right mr-3" @click="removeSingeFirst(i, f)"
                                          v-show="combo.config.more_first"></i>
                                        </div>
                                        <b-button variant="primary" class="border-radius-4px bg-main"
                                                v-on:click="addSingleSecond(i, f)" v-show="combo.config.more_second"><i
                                          class="fa fa-plus"></i>&nbsp; {{$t('combo.crust')}}
                                        </b-button>
                                        <div class="ml-3">
                                          <button type="button" class="btn btn-md border-radius-4px bg-main btn-primary" @click="updateGroupSizeShow($event,i + '-' + f)">
                                            <i class="fa fa-angle-up" v-if="groupSizeShow[i + '-' + f]"></i>
                                            <i class="fa fa-angle-down" v-if="!groupSizeShow[i + '-' + f]"></i>
                                          </button>
                                        </div>
                                    </b-col>
                                  </b-row>
                                </div>
                                <b-collapse v-model="groupSizeShow[i + '-' + f]" :id="'combo-group-size-' + i + '-' + f">
                                  <div class="option-second">
                                    <draggable :disabled="!enabled" class="row" ghost-class="ghost" v-model="first.second_layers" :group="{name: 'combo-pizza-first-second', put: true, pull: false}" draggable=".list-item-first-second"  @start="isDragging=true" @end="isDragging=false">
                                      <div class="col-lg-4 col-md-6 list-item-first-second" v-for="(second, s) in first.second_layers"
                                          :key="second.uuid">
                                        <div class="second-box">
                                          <div class="d-flex justify-content-between">
                                            <div class="d-flex align-items-center">
                                              <span class="size-label">{{$t('combo.active')}}</span>
                                              <span class="text-main font-weight-600 active-second">
                                                <c-switch type="icon" class="switch-customize" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                                          :pill="true"
                                                          v-model="itemGroup.first_layers[f].second_layers[s].active" :value="1"
                                                          :key="'witch-customize-second-layers'+i+'-'+f+'-'+key"
                                                          @change="inActive('second', {itemIndex: i, firstIndex: f, secondIndex: s, active: itemGroup.first_layers[f].second_layers[s].active})"
                                                          :uncheckedValue="0"/>
                                              </span>
                                            </div>
                                            <div class="d-flex align-items-center pl-2 pr-2" :class="combo.config.set_default && itemGroup.default && itemGroup.first_layers[f].default && !objDefault.second ? 'br-color-default' : ''"  v-if="combo.config.set_default && itemGroup.default && itemGroup.first_layers[f].default">
                                              <span class="size-label">{{$t('combo.set_default')}}</span>
                                              <span class="text-main font-weight-600 active-second" >
                                                <c-switch-custom type="icon" class="switch-customize" variant="primary" v-bind="{on: '\uf00c', off: '\uf00d'}"
                                                          :pill="true"
                                                          :disabled="itemGroup.first_layers[f].second_layers[s].active ? false : true "
                                                          v-model="itemGroup.first_layers[f].second_layers[s].default" :value="1"
                                                          @change="setDefault('second', {itemIndex: i, firstIndex: f, secondIndex: s} )"
                                                          :uncheckedValue="0"/>
                                              </span>
                                            </div>
                                            
                                            <span class="close-btn" @click="removeSingeSecond(i, f, s)"
                                                  v-show="combo.config.more_second">
                                              <i class="fa fa-trash-o text-main"></i>
                                            </span>
                                          </div>
                                          <b-form-group v-for="lang in $store.getters.languages" label-class="hidden"
                                                        :key="lang.id">
                                            <b-form-input autocomplete="off"
                                                          :list="'name_second_layer_list_' + lang + '_' + f + '_' + s"
                                                          @change="updateSecondLayerItems(i, f, s, $event, lang)" type="text"
                                                          class="form-control border-radius-4px"
                                                          v-model="itemGroup.first_layers[f].second_layers[s].name[lang]"
                                                          v-bind:placeholder="$t('common.text_'+lang)"/>
                                            <datalist :id="'name_second_layer_list_' + lang + '_' + f + '_' + s"
                                                      v-if="first_layer_options.length > 0 && second_layer_options.length > 0">
                                              <option v-for="second_option in second_layer_options" :key="second_option.id"
                                                      v-bind:value="second_option.name[lang]"
                                                      v-bind:label="second_option.name[lang]"></option>
                                            </datalist>
                                          </b-form-group>
                                          <div class="full-width d-flex">
                                            <div class="size-label">{{$t('combo.code')}}</div>
                                            <div class="size-code-input no-padding">
                                              <b-form-input type="text" class="form-control border-radius-4px"
                                                            v-model="itemGroup.first_layers[f].second_layers[s].sku"/>
                                            </div>
                                          </div>
                                          <div class="full-width d-flex mt-3" v-show="combo.config.second_price">
                                            <div class="size-label" v-if="_.size(tier) <= 1">{{$t('combo.price')}}
                                              ({{currency.symbol}})
                                            </div>
                                            <div class="flex-1"
                                                v-if="_.size(tier) <= 1 && combo.config.second_multi_price != true && combo.config.product_tax_price != true">
                                              <div class="full-width"
                                                  v-for="(price, p) in itemGroup.first_layers[f].second_layers[s].prices"
                                                  :key="price.id">
                                                <input type="hidden" class="form-control"
                                                      v-model="itemGroup.first_layers[f].second_layers[s].prices[p].active"/>
                                                <input type="hidden" class="form-control"
                                                      v-model="itemGroup.first_layers[f].second_layers[s].prices[p].from"/>
                                                <input type="hidden" class="form-control"
                                                      v-model="itemGroup.first_layers[f].second_layers[s].prices[p].to"/>
                                                <input type="hidden" class="form-control"
                                                      v-model="itemGroup.first_layers[f].second_layers[s].prices[p].tax_rate"/>
                                                <div v-for="(name, index) in tier" class="full-width">
                                                  <b-form-input type="number" min="0" class="form-control border-radius-4px"
                                                                v-model="itemGroup.first_layers[f].second_layers[s].prices[p].price[index]"
                                                                v-bind:placeholder="$t('combo.price')"
                                                                :disabled="checkDisableByConfig('second', 'price')">
                                                  </b-form-input>
                                                  <input type="hidden" class="form-control"
                                                        v-model="itemGroup.first_layers[f].second_layers[s].prices[p].price_without_tax[index]"/>
                                                </div>
                                              </div>
                                            </div>
                                            <div class="flex-1"
                                                v-if="_.size(tier) > 1 || combo.config.second_multi_price == true || combo.config.product_tax_price == true">
                                              <button type="button" class="btn bg-main border-radius-4px"
                                                      @click="showModal('second_'+i+'_'+f+'_'+s)">{{$t('combo.edit_price')}}
                                              </button>
                                            </div>
                                            <div class="flex-1 pt-5px pl-10px">

                                            </div>
                                          </div>
                                          <b-modal :id="'second_'+i+'_'+f+'_'+s" centered
                                                  :title="$t('combo.crust_price')+'('+currency.symbol+')'">
                                            <div class="row" v-if="combo.config.second_multi_price">
                                              <div class="col-sm-12 mb-2 text-main">
                                                <span class="button-text border-radius-4px"
                                                      @click="addPriceToSingleSecond(i, f, s)"><i class="fa fa-plus"></i> {{$t('common.add')}}</span>
                                              </div>
                                            </div>

                                            <div class="full-width"
                                                v-for="(price, p) in itemGroup.first_layers[f].second_layers[s].prices"
                                                :key="price.id">
                                              <input type="hidden" class="form-control"
                                                    v-model="itemGroup.first_layers[f].second_layers[s].prices[p].active"/>
                                              <div class="row bg-secondary py-2 d-flex"
                                                  v-if="combo.config.second_multi_price">
                                                <div class="d-flex flex-1 px-3">
                                                  <div class="size-label">{{$t('combo.from')}}</div>
                                                  <div class="size-code-input">
                                                    <masked-input
                                                      type="text"
                                                      name="date"
                                                      class="form-control border-radius-4px"
                                                      v-model="itemGroup.first_layers[f].second_layers[s].prices[p].from"
                                                      :mask="[/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/]"
                                                      :guide="true"
                                                      placeholderChar="_"
                                                      :showMask="true"
                                                      :keepCharPositions="true">
                                                    </masked-input>
                                                  </div>
                                                </div>
                                                <div class="d-flex flex-1 px-3">
                                                  <div class="size-label text-right">{{$t('combo.to')}}</div>
                                                  <div class="size-code-input">
                                                    <masked-input
                                                      type="text"
                                                      name="date"
                                                      class="form-control border-radius-4px"
                                                      v-model="itemGroup.first_layers[f].second_layers[s].prices[p].to"
                                                      :mask="[/\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/]"
                                                      :guide="true"
                                                      placeholderChar="_"
                                                      :showMask="true"
                                                      :keepCharPositions="true">
                                                    </masked-input>
                                                  </div>
                                                </div>
                                                <div class="auto-width px-3 button-text">
                                                  <i class="fa fa-trash-o text-main"
                                                    @click="removePriceToSingleSecond(i, f, s, p)"></i>
                                                </div>
                                              </div>
                                              <div class="row py-2">
                                                <div class="col-sm-12" v-if="combo.config.product_tax_price">
                                                  <b-form-group v-bind:label="$t('combo.tax_rate')">
                                                    <input type="number" class="form-control"
                                                      v-model="itemGroup.first_layers[f].second_layers[s].prices[p].tax_rate"/>
                                                  </b-form-group>
                                                </div>
                                                <div class="col-sm-6 d-flex mb-3" v-for="(name, index) in tier">
                                                  <b-card class="w-100 pb-0" v-bind:title="name ? name : $t('combo.tier') + ' ' + index">
                                                    <b-form-group>
                                                      <b-row>
                                                        <div class="col-sm-12">
                                                          <b-form-group v-bind:label="$t('combo.price')">
                                                            <b-form-input type="number" min="0" class="form-control border-radius-4px"
                                                                  v-model="itemGroup.first_layers[f].second_layers[s].prices[p].price[index]"
                                                                  v-bind:placeholder="$t('combo.price')"
                                                                  :disabled="checkDisableByConfig('second', 'price')">
                                                            </b-form-input>
                                                          </b-form-group>
                                                        </div>
                                                        <div class="col-sm-12" v-if="combo.config.product_tax_price">
                                                          <b-form-group v-bind:label="$t('combo.price_without_tax')">
                                                            <input type="number" class="form-control"
                                                              v-model="itemGroup.first_layers[f].second_layers[s].prices[p].price_without_tax[index]"/>
                                                          </b-form-group>
                                                        </div>
                                                      </b-row>
                                                    </b-form-group>
                                                  </b-card>
                                                </div>
                                              </div>
                                            </div>
                                            <div slot="modal-footer" class="full-width">
                                              <button type="button" class="btn bg-main float-right border-radius-4px"
                                                      v-on:click="hideModal('second_'+i+'_'+f+'_'+s)">{{$t('common.save')}}
                                              </button>
                                            </div>
                                          </b-modal>
                                        </div>
                                      </div>
                                    </draggable>
                                  </div>
                                </b-collapse>
                              </div>
                            </draggable>
                          </b-form>
                        </b-row>
                        <!-- End of Single Layers -->
                      </b-collapse>
                    </b-card>
                  </b-col>
                </b-row>
              </draggable>
              <b-row>
                <b-col cols="2" class="form-row">

                  <b-input-group>
                    <b-form-input v-model="quantityMenuItem" @change="changeQuantityMenuItem" @keyup="changeQuantityMenuItem" class="no-input-button"></b-form-input>
                    <b-input-group-append>
                      <b-button variant="primary" class="border-radius-4px bg-main" v-on:click="addItem()"
                                v-show="combo.config.more_item">
                        <i class="fa fa-plus"></i>&nbsp;
                        {{$t('combo.menu_item')}}
                      </b-button>
                    </b-input-group-append>
                  </b-input-group>

                </b-col>
              </b-row>
              <!-- Added here -->
            </div>
            <div slot="footer">
              <div class="back-button">
                <button type="button" class="btn border-radius-4px bg-main float-left" @click="$router.back()"><i
                  class="fa fa-arrow-left"></i> {{$t('common.back')}}
                </button>
              </div>
              <div class="btn-save">
                <button type="button" class="btn pull-right border-radius-4px bg-main"
                        v-on:click="finishCreateComboGroup">&nbsp; {{$t('common.save_this_group')}}
                </button>
                <button type="button" class="btn pull-right border-radius-4px bg-main mr-2"
                        v-on:click="cloneComboGroup">&nbsp; {{$t('common.clone_this_group')}}
                </button>
              </div>
              <div class="text-center">
              </div>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import {validationMixin} from 'vuelidate'
  import {required, minLength, maxLength, between, integer, minValue} from 'vuelidate/lib/validators'
  import cSwitch from '../../../components/Switch'
  import cSwitchCustom from '../../../components/SwitchCustom'
  import vSelect from 'vue-select'
  import MaskedInput from 'vue-text-mask'
  import CustomizeField from '../../../components/Partials/CustomizeField'
  import Tables from '../../tables/Tables'
  import {ModelSelect} from 'vue-search-select'
  import Multiselect from 'vue-multiselect'
  import Draggable from 'vuedraggable'

  const defaultDateFrom = '2008-01-01'
  const defaultDateTo = '9999-12-31'
  let vm = null
  export default {
    name: 'ComboGroupForm',
    props: {
      uuid: {
        type: String,
        required: true
      }
    },
    components: {
      Tables,
      cSwitch,
      cSwitchCustom,
      vSelect,
      ModelSelect,
      MaskedInput,
      CustomizeField,
      Multiselect,
      Draggable
    },
    data: function () {
      return {
        enabled: true,
        itemLimit: 9999999,
        flagProccess: true,
        deleteGroups: [],
        comboPrice: false, // test
        addNewComboGroup: true,
        tier: this.$store.getters.config.main.tiers,
        combo: this.$store.getters.config.gms.combo,
        // images: ["desktop_thumbnail", "desktop_detail", "mobile_thumbnail", "mobile_detail"],
        currency: this.$store.getters.config.gms.currency_info,
        daysOfWeek: this.$auth.user().config.days_of_week,
        quantityMenuItem: '1',
        key: 0,
        item: {
          combo_id: 0,
          combo_uuid: '',
          groups: []
        },
        objDefault: {
          single: true,
          first: true,
          second: true
        },
        itemDefault: {},
        menuItems: {},
        imageData: {},
        headerName: '',
        enableCrushSize: [],
        groupHidden: [],
        groupStatus: [],
        groupItemShow: [],
        groupSizeShow: [],
        isCreate: true,
        first_layer_options: [],
        second_layer_options: [],
        active_group_uuid: '',
        group: {
          name: {
            en:"Group 0",
          },
          items: [],
          uuid: "",
          sequence: 0,
          min: 1,
          max: 1,
          image: {},
          imageData: {},
          active: 1,
          menuItemSelected: [],
          priceStatus: [],
          newGroup: 1
        },
        menuItemSelected: [
          {
            text: '',
            value: ''
          }
        ],
        groupValue: {}
      }
    },
    mixins: [
      validationMixin
    ],
    validations: {
      item: {
        name: {
          required
        },
        sequence: {
          required,
          minValue: 0,
          integer
        },
        min: {
          required
        },
        max: {
          required
        }
      }
    },
    methods: {
      updateGroupSizeShow(event, i) {
        let vm = this
        vm.groupSizeShow[i] = !vm.groupSizeShow[i]
        this.$forceUpdate('groupSizeShow[' + i + ']')
      },
      checkMoveItems(event) {
        let vm = this
        vm.menuItemSelected = []
        for (let i = 0; i < vm.group.items.length; i++) {
          vm.menuItemSelected[i] = {
            text: vm.group.items[i].single.name[vm.$session.get('lang')] + ' | ' + vm.group.items[i].single.sku,
            value: vm.group.items[i].single.uuid
          }
        }
      },
      sortData() {
        const sortData = JSON.parse(JSON.stringify(this.group.items))
        sortData.sort(function(a, b){return a.sequence - b.sequence});

        sortData.map((item) => {
          return item.first_layers.sort( function(c, d) {return c.sequence - d.sequence} )
        })

        sortData.map((item) => {
          return item.first_layers.map((first) => {
            return first.second_layers.sort( function(x, z) {return x.sequence - z.sequence})
          })
        })

        return sortData
      },
      changeQuantityMenuItem () {
        var numbers = /^[-+]?[0-9]+$/;
          if ((this.quantityMenuItem && !this.quantityMenuItem.match(numbers)) ||  this.quantityMenuItem*1 == 0 || this.quantityMenuItem*1 > 10) {
          this.quantityMenuItem = '1'
        }
      },
      checkShowByConfig(layer, key) {
        if (this.combo == null) {
          return true
        }
        let config = this._.find(this.combo[layer], function (o) {
          return o.type === key
        })
        if (config == null) {
          return false
        }
        return config.show
      },
      checkDisableByConfig(layer, key) {
        if (this.item.content_status == 75) {
          return true
        }
        if (this.combo == null) {
          return false
        }
        let config = this._.find(this.combo[layer], {type: key})
        if (config == null) {
          return false
        }
        return config.disable
      },
      previewImageComboGroup(event) {
        let input = event.target
        if (input.files && input.files[0]) {
          let reader = new FileReader()
          reader.onload = (e) => {
            vm.group.imageData[input.id] = e.target.result
          }
          let data = {}
          for (let i in vm.images) {
            data[vm.images[i]] = vm.group.imageData[vm.images[i]]
          }
          vm.group.imageData = data
          reader.readAsDataURL(input.files[0])
          vm.group.image[input.id] = input.files[0]
        }
      },
      getMenuList() {
        // get params
        let _data = {
          limit: vm.itemLimit,
          active: 1
        }
        // process to send via get method
        let params = ''
        for (let key in _data) {
          params += key + '=' + _data[key] + '&'
        }
        // remove tail
        params = params.slice(0, -1)
        vm.axios.menu.getMenuListForCombobox(params,
          function (response) {
            let langs = vm.$store.getters.languages
            for (let l in langs) {
              let lang = langs[l]
              vm.menuItems[lang] = []
              for (let c in response.data.data.items) {
                let item = response.data.data.items[c]
                if (item['name'] != null && item['name'][lang] != undefined && item['name'][lang] != '') {
                  vm.menuItems[lang].push({
                    value: item['uuid'],
                    text: item['name'][lang] + ' | ' + item['sku'],
                    name: item['name'][lang],
                    sku: item['sku'],
                    selling_end: item.selling_end,
                    selling_start: item.selling_start,
                    default: item.default
                  })
                } else {
                  vm.menuItems[lang].push({
                    value: item['uuid'],
                    text: 'Invalid Name (' + item['sku'] + ')',
                    sku: item['sku'],
                    selling_end: item.selling_end,
                    selling_start: item.selling_start,
                    default: item.default
                  })
                }
              }
              vm.$forceUpdate('menuItems[' + lang + ']')
            }
          }
        )
      },
      getFirstLayerOptions() {
        let params = 'active=1&limit=9999'
        vm.axios.menu.getFirstLayerList(params, function (response) {
          vm.first_layer_options = response.data.data.items
        })
      },
      getSecondLayerOptions() {
        let params = 'active=1&limit=9999'
        vm.axios.menu.getSecondLayerList(params, function (response) {
          vm.second_layer_options = response.data.data.items
        })
      },
      moveToNewGroup(uuid){
        vm.active_group_uuid = uuid
        for (const group of vm.item.groups) {
          if (group.uuid == uuid) {
            vm.group = vm._.cloneDeep(group)
            vm.resetGroup()
            vm.groupValue = vm._.cloneDeep(vm.group)
            break
          }
        }
        vm.objDefault.single = true
        vm.objDefault.first = true
        vm.objDefault.second = true
      },
      updateActiveGroupUuid(uuid) {
        if (vm.active_group_uuid != uuid) {
          if ((JSON.stringify(vm.groupValue) === JSON.stringify(vm.group) || vm.groupValue.uuid === undefined) && vm.group.newGroup != 1) {
            vm.moveToNewGroup(uuid)
          } else {
            let options = {
              html: true,
              okText: vm.$t('common.save'),
              cancelText: vm.$t('common.cancel')
            }
            vm.$dialog.confirm(vm.$t('message.confirm'), options)
              .then(function (dialog) {
                vm.saveComboGroup(function () {
                  vm.moveToNewGroup(uuid)
                })
              })
              .catch(function () {
                vm.moveToNewGroup(uuid)
              })
          }
        }
      },
      changeMenuItem(index) {
        // raise an event to change menu item
        let uuid = vm.menuItemSelected[index].value
        vm.groupItemShow[index] = true
        if (uuid != '') {
          let groupItem = vm.group.items[index]
          // get menu item detail
          vm.axios.getMenuDetail(uuid, function (response) {
            groupItem.single = response.data.data.item
            // change date for opening times
            for (let i = 0; i < response.data.data.item.opening_times.length; i++) {
              let it = response.data.data.item.opening_times[i]
              groupItem.opening_times[it.day] = it
            }

            // change date for special dates
            // let specialDates = []
            // for (let k in response.data.data.item.special_dates) {
            //   specialDates.push({
            //     'date': response.data.data.item.special_dates[k].date,
            //     'active': response.data.data.item.special_dates[k].active,
            //     'from': response.data.data.item.special_dates[k].from,
            //     'name': response.data.data.item.special_dates[k].name,
            //     'status': response.data.data.item.special_dates[k].status,
            //     'to': response.data.data.item.special_dates[k].to
            //   })
            // }
            // groupItem.special_dates = specialDates

            // update single_id for the current group
            groupItem.single_id = response.data.data.item.id

            // change date for prices
            let prices = []
            let priceDefault = {}
            for (let t in vm.tier) {
              priceDefault[t] = 0
            }
            if (response.data.data.item.prices.length > 0) {
              for (let i in response.data.data.item.prices) {
                let price = {}
                price['from'] = response.data.data.item.prices[i].from
                price['to'] = response.data.data.item.prices[i].to
                price['price'] = response.data.data.item.prices[i].price
                price['price_without_tax'] = response.data.data.item.prices[i].price_without_tax != null ? response.data.data.item.prices[i].price_without_tax : priceDefault
                price['tax_rate'] = response.data.data.item.prices[i].tax_rate != null ? response.data.data.item.prices[i].tax_rate : 0

                prices.push(price)
              }
            } else {
              prices.push({
                from: defaultDateFrom,
                to: defaultDateTo,
                price: priceDefault,
                price_without_tax: priceDefault,
                tax_rate: 0,
                active: 1
              })
            }
            groupItem.prices = prices

            // change date for first layers
            if (response.data.data.item.first_layers.length > 0) {
              let firstLayers = response.data.data.item.first_layers
              for (let i in firstLayers) {
                // prices for first layers
                if (firstLayers[i].prices.length > 0) {
                  for (let j in firstLayers[i].prices) {
                    firstLayers[i].prices[j]['from'] = response.data.data.item.first_layers[i].prices[j].from
                    firstLayers[i].prices[j]['to'] = response.data.data.item.first_layers[i].prices[j].to
                    firstLayers[i].prices[j]['price'] = response.data.data.item.first_layers[i].prices[j].price
                    firstLayers[i].prices[j]['price_without_tax'] = response.data.data.item.first_layers[i].prices[j].price_without_tax != null ? response.data.data.item.first_layers[i].prices[j].price_without_tax : priceDefault
                    firstLayers[i].prices[j]['tax_rate'] = response.data.data.item.first_layers[i].prices[j].tax_rate != null ? response.data.data.item.first_layers[i].prices[j].tax_rate : 0
                  }
                } else {
                  firstLayers[i].prices = []
                  firstLayers[i].prices.push({
                    from: defaultDateFrom,
                    to: defaultDateTo,
                    price: priceDefault,
                    price_without_tax: priceDefault,
                    tax_rate: 0,
                    active: 1
                  })
                }

                // prices for second_layers
                let secondLayers = firstLayers[i].second_layers
                for (let j in secondLayers) {
                  if (secondLayers[j].prices.length > 0) {
                    for (let k in secondLayers[j].prices) {
                      secondLayers[j].prices[k]['from'] = response.data.data.item.first_layers[i].second_layers[j].prices[k].from
                      secondLayers[j].prices[k]['to'] = response.data.data.item.first_layers[i].second_layers[j].prices[k].to
                      secondLayers[j].prices[k]['price'] = response.data.data.item.first_layers[i].second_layers[j].prices[k].price
                      secondLayers[j].prices[k]['price_without_tax'] = response.data.data.item.first_layers[i].second_layers[j].prices[k].price_without_tax != null ? response.data.data.item.first_layers[i].second_layers[j].prices[k].price_without_tax : priceDefault
                      secondLayers[j].prices[k]['tax_rate'] = response.data.data.item.first_layers[i].second_layers[j].prices[k].tax_rate != null ? response.data.data.item.first_layers[i].second_layers[j].prices[k].tax_rate : 0
                    }
                  } else {
                    secondLayers[j].prices = []
                    secondLayers[j].prices.push({
                      from: defaultDateFrom,
                      to: defaultDateTo,
                      price: priceDefault,
                      price_without_tax: priceDefault,
                      tax_rate: 0,
                      active: 1
                    })
                  }
                }
                firstLayers[i].second_layers = secondLayers
              }
              groupItem.first_layers = firstLayers
            } else {
              groupItem.first_layers = []
            }

            vm.group.items[index] = groupItem
          })
        } else {
          let days = {}
          for (let i in vm.daysOfWeek) {
            days[vm.daysOfWeek[i]] = {
              day: vm.daysOfWeek[i],
              opening: '08:00:00',
              closing: '23:00:00',
              active: 1
            }
          }
          vm.group.items[index]['single_id'] = ''
          vm.group.items[index]['opening_times'] = days
          vm.group.items[index]['special_dates'] = []
          vm.group.items[index]['prices'] = []
          vm.group.items[index]['first_layers'] = []
        }
        // enable save group button
      },
      resetGroup() {
        let priceDefault = {}
        for (let t in vm.tier) {
          priceDefault[t] = 0
        }

        vm.menuItemSelected = []
        for (let i = 0; i < vm.group.items.length; i++) {
          vm.groupItemShow[i] = false
          vm.menuItemSelected[i] = {
            text: vm.group.items[i].single.name[vm.$session.get('lang')] + ' | ' + vm.group.items[i].single.sku,
            value: vm.group.items[i].single.uuid
          }

          let openingTimes = vm.group.items[i].opening_times
          vm.group.items[i].openingTimes = []
          for (let k = 0; k < openingTimes.length; k++) {
            let it = openingTimes[k]
            vm.group.items[i].opening_times[it.day] = it
          }

          // change date for special dates
          // let specialDates = vm.group.items[i].special_dates
          // vm.group.items[i].special_dates = []
          // for (let k = 0; k < specialDates.length; k++) {
          //   vm.group.items[i].special_dates.push({
          //     'date': vm.convertDateFormat(specialDates[k].date),
          //     'active': specialDates[k].active,
          //     'from': specialDates[k].from,
          //     'name': specialDates[k].name,
          //     'status': specialDates[k].status,
          //     'to': specialDates[k].to
          //   })
          // }

          // change date for prices
          let prices = vm.group.items[i].prices
          vm.group.items[i].prices = []
          if (prices.length > 0) {
            for (let k = 0; k < prices.length; k++) {
              vm.group.items[i].prices.push({
                'from': prices[k].from,
                'to': prices[k].to,
                'price': vm.formatPriceByTier(prices[k].price,vm.tier),
                'price_without_tax': vm.formatPriceByTier(prices[k].price_without_tax,vm.tier),
                'tax_rate': prices[k].tax_rate != null ? prices[k].tax_rate : 0
              })
            }
          } else {
            vm.group.items[i].prices.push({
              from: defaultDateFrom,
              to: defaultDateTo,
              price: priceDefault,
              price_without_tax: priceDefault,
              tax_rate: 0,
              active: 1
            })
          }

          // change date for first layer
          let firstLayers = vm.group.items[i].first_layers
          for (let k = 0; k < firstLayers.length; k++) {
            let prices = []
            if (firstLayers[k].prices.length > 0) {
              for (let l in firstLayers[k].prices) {
                prices.push({
                  'from': firstLayers[k].prices[l].from,
                  'to': firstLayers[k].prices[l].to,
                  'price': vm.formatPriceByTier(firstLayers[k].prices[l].price,vm.tier),
                  'price_without_tax': vm.formatPriceByTier(firstLayers[k].prices[l].price_without_tax ,vm.tier),
                  'tax_rate': firstLayers[k].prices[l].tax_rate != null ? firstLayers[k].prices[l].tax_rate : 0,
                  'active': firstLayers[k].prices[l].active
                })
              }
            } else {
              prices.push({
                from: defaultDateFrom,
                to: defaultDateTo,
                price: priceDefault,
                price_without_tax: priceDefault,
                tax_rate: 0,
                active: 1
              })
            }
            vm.group.items[i].first_layers[k].prices = prices

            let secondLayers = firstLayers[k].second_layers
            for (let l in secondLayers) {
              let pricesSeconds = []
              if (secondLayers[l].prices.length > 0) {
                for (let m in secondLayers[l].prices) {
                  pricesSeconds.push({
                    'from': secondLayers[l].prices[m].from,
                    'to': secondLayers[l].prices[m].to,
                    'price': vm.formatPriceByTier(secondLayers[l].prices[m].price,vm.tier),
                    'price_without_tax': vm.formatPriceByTier(secondLayers[l].prices[m].price_without_tax,vm.tier),
                    'tax_rate': secondLayers[l].prices[m].tax_rate != null ? secondLayers[l].prices[m].tax_rate : 0,
                    'active': secondLayers[l].prices[m].active
                  })
                }
              } else {
                pricesSeconds.push({
                  from: defaultDateFrom,
                  to: defaultDateTo,
                  price: priceDefault,
                  price_without_tax: priceDefault,
                  tax_rate: 0,
                  active: 1
                })
              }
              vm.group.items[i].first_layers[k].second_layers[l].prices = pricesSeconds
            }
          }
        }
      },
      copySku(index) {
        let menu = vm.group.items[index]
        if (menu) {
          const el = document.createElement('input')
          el.value = menu.single.sku
          document.body.appendChild(el)
          el.select()
          document.execCommand('copy')
          document.body.removeChild(el)
        }
      },
      setDefault(type, objectIndex) {
      let vm = this
        switch (type) {
          case 'menu':
            vm.objDefault.single = false
            vm.objDefault.first = false
            vm.objDefault.second = false
            for (let i = 0; i < vm.group.items.length; i++) {
              if (objectIndex.itemIndex == i && vm.group.items[objectIndex.itemIndex].default) {
                vm.objDefault.single = true
                vm.itemDefault = vm.group.items[objectIndex.itemIndex]
                vm.groupItemShow[i] = true
                vm.$forceUpdate('groupItemShow[' + i + ']')
                continue;
              } 
              vm.groupItemShow[i] = false
              vm.$forceUpdate('groupItemShow[' + i + ']')
              vm.group.items[i].default = 0
              vm.group.items[i].first_layers.map(first => {
                first.default = 0
                first.second_layers.map(second => {
                  second.default = 0
                })
              })
            }
          break;
          case 'first':
            vm.objDefault.first = false
            vm.objDefault.second = false
            for (let firstIndex = 0; firstIndex < vm.group.items[objectIndex.itemIndex].first_layers.length; firstIndex++) {
              if (objectIndex.firstIndex == firstIndex && vm.group.items[objectIndex.itemIndex].first_layers[firstIndex].default) {
                vm.objDefault.first = true
                continue;
              } 
              vm.group.items[objectIndex.itemIndex].first_layers[firstIndex].default = 0
              vm.group.items[objectIndex.itemIndex].first_layers.map(first => {
              first.second_layers.map(second => {
                second.default = 0
              })
            })
            }
          break;
          case 'second':
            vm.objDefault.second = false
            for (let secondIndex = 0; secondIndex < vm.group.items[objectIndex.itemIndex].first_layers[objectIndex.firstIndex].second_layers.length; secondIndex++) {
                if (objectIndex.secondIndex == secondIndex && vm.group.items[objectIndex.itemIndex].first_layers[objectIndex.firstIndex].second_layers[secondIndex].default) {
                  vm.objDefault.second = true
                  continue;
                }
                vm.group.items[objectIndex.itemIndex].first_layers[objectIndex.firstIndex].second_layers[secondIndex].default = 0
              }
          break;
          default:
            break;
        }
        
      },
      removeItem(index) {
        let options = {
          html: true,
          okText: vm.$t('common.delete'),
          cancelText: vm.$t('common.cancel')
        }
        vm.$dialog.confirm(vm.$t('message.delete_confirm'), options)
          .then(function (dialog) {
            let items = []
            let menuItemSelectedItems = []
            for (let i in vm.group.items) {
              if (i != index) {
                items.push(vm.group.items[i])
                menuItemSelectedItems.push(vm.menuItemSelected[i])
              }
            }
            vm.group.items = items
            vm.menuItemSelected = menuItemSelectedItems
          })
          .catch(function () {
          })
      },
      removeSpecialDate(i, index) {
        let dates = []
        for (let i in vm.group.items[i].special_dates) {
          if (i != index) {
            dates.push(vm.group.items[i].special_dates[i])
          }
        }
        vm.group.items[i].special_dates = dates
      },
      addSpecialDate(i) {
        vm.group.items[i].special_dates.push({
          name: '',
          from: '08:00:00',
          to: '02:00:00',
          date: this.$moment().format('YYYY-MM-DD'),
          status: 1,
          active: 1
        })
      },
      addPriceToSingle(i) {
        let prices = {}
        let price_without_tax = {}
        for (let t in vm.tier) {
          prices[t] = 0,
          price_without_tax[t] = 0
        }
        vm.group.items[i].prices.push({
          from: defaultDateFrom,
          to: defaultDateTo,
          price: prices,
          price_without_tax: price_without_tax,
          tax_rate: 0,
          active: 1
        })
      },
      removePriceToSingle(itemIndex, priceIndex) {
        let layers = []
        for (let i in vm.group.items[itemIndex].prices) {
          if (i != priceIndex) {
            layers.push(vm.group.items[itemIndex].prices[i])
          }
        }
        vm.group.items[itemIndex].prices = layers

        // enable save group button
        // vm.addNew = true
      },
      updateFirstLayerItems(indexItem, indexFirst, event, lang) {
        let firstLayer
        if (lang == null) {
          firstLayer = this.first_layer_options.find(f => f.sku === event)
        } else {
          firstLayer = this.first_layer_options.find(f => f.name[lang] === event)
        }

        if (firstLayer) {
          for (let i in vm.$store.getters.languages) {
            if (vm.$store.getters.languages.hasOwnProperty(i)) {
              vm.group.items[indexItem].first_layers[indexFirst].name[vm.$store.getters.languages[i]] = firstLayer.name[vm.$store.getters.languages[i]]
            }
          }
          vm.group.items[indexItem].first_layers[indexFirst].sku = firstLayer.sku
          vm.group.items[indexItem].first_layers[indexFirst].first_id = firstLayer.id
          vm.group.items[indexItem].first_layers[indexFirst].short_name = firstLayer.short_name
        }
      },
      addPriceToSingleFirst(i, f) {
        let prices = {}
        let price_without_tax = {}
        for (let t in vm.tier) {
          prices[t] = 0,
          price_without_tax[t] = 0
        }
        vm.group.items[i].first_layers[f].prices.push({
          from: defaultDateFrom,
          to: defaultDateTo,
          price: prices,
          price_without_tax: price_without_tax,
          tax_rate: 0,
          active: 1
        })
      },
      removePriceToSingleFirst(itemIndex, firstIndex, priceIndex) {
        let prices = []
        for (let i in vm.group.items[itemIndex].first_layers[firstIndex].prices) {
          if (i != priceIndex) {
            prices.push(vm.group.items[itemIndex].first_layers[firstIndex].prices[i])
          }
        }
        vm.group.items[itemIndex].first_layers[firstIndex].prices = prices
      },
      addSingleSecond(i, f) {
        vm.groupSizeShow[i + '-' + f] = true
        let price = {}
        let price_without_tax = {}
        let prices = []
        for (let t in vm.tier) {
          price[t] = 0,
          price_without_tax[t] = 0
        }
        prices.push({
          from: defaultDateFrom,
          to: defaultDateTo,
          price: price,
          price_without_tax: price_without_tax,
          tax_rate: 0,
          active: 1
        })

        let lang = {}
        for (let l in vm.$store.getters.languages) {
          lang[vm.$store.getters.languages[l]] = ''
        }
        vm.group.items[i].first_layers[f].second_layers.push({
          name: lang,
          prices: prices,
          special_dates: [],
          opening_times: [],
          sku: '',
          image: {},
          active: 1
        })
      },
      inActive(type, object) {
        let vm = this
        switch (type) {
          case 'first':
            if (!object.active && vm.group.items[object.itemIndex].first_layers[object.firstIndex].default) {
              vm.group.items[object.itemIndex].first_layers[object.firstIndex].active = 1
              vm.key++
              vm.$dialog.alert(vm.$t('message.cant_not_delete'), {html: true, okText: vm.$t('common.ok')})
              return
            }
            
            break;
          case 'second':
            if (!object.active && vm.group.items[object.itemIndex].first_layers[object.firstIndex].second_layers[object.secondIndex].default) {
              vm.group.items[object.itemIndex].first_layers[object.firstIndex].second_layers[object.secondIndex].active = 1
              vm.key++
              vm.$dialog.alert(vm.$t('message.cant_not_delete'), {html: true, okText: vm.$t('common.ok')})
              return
            }
          
          break;
        
          default:
            break;
        }
      },
      removeSingeFirst(itemIndex, firstIndex) {
        if (vm.group.items[itemIndex].first_layers[firstIndex].default) {
          vm.$dialog.alert(vm.$t('message.cant_not_delete'), {html: true, okText: vm.$t('common.ok')})
          return
        }
        let options = {
          html: true,
          okText: vm.$t('common.delete'),
          cancelText: vm.$t('common.cancel')
        }
        vm.$dialog.confirm(vm.$t('message.delete_confirm'), options)
          .then(function (dialog) {
            let layers = []
            for (let i in vm.group.items[itemIndex].first_layers) {
              if (i != firstIndex) {
                layers.push(vm.group.items[itemIndex].first_layers[i])
              }
            }
            vm.group.items[itemIndex].first_layers = layers
          })
          .catch(function () {
          })
      },
      removeSingeSecond(itemIndex, firstIndex, secondIndex) {
        if (vm.group.items[itemIndex].first_layers[firstIndex].second_layers[secondIndex].default) {
          vm.$dialog.alert(vm.$t('message.cant_not_delete'), {html: true, okText: vm.$t('common.ok')})
          return
        }
        let options = {
          html: true,
          okText: vm.$t('common.delete'),
          cancelText: vm.$t('common.cancel')
        }
        vm.$dialog.confirm(vm.$t('message.delete_confirm'), options)
          .then(function (dialog) {
            let layers = []
            for (let i in vm.group.items[itemIndex].first_layers[firstIndex].second_layers) {
              if (i != secondIndex) {
                layers.push(vm.group.items[itemIndex].first_layers[firstIndex].second_layers[i])
              }
            }
            vm.group.items[itemIndex].first_layers[firstIndex].second_layers = layers
          })
          .catch(function () {
          })
      },
      updateSecondLayerItems(indexItem, indexFirstLayer, indexSecondLayer, event, lang) {
        let secondLayer
        if (lang === undefined) {
          secondLayer = vm.second_layer_options.find(s => s.sku === event)
        } else {
          secondLayer = vm.second_layer_options.find(s => s.name[lang] === event)
        }

        if (secondLayer) {
          for (let i in vm.$store.getters.languages) {
            if (vm.$store.getters.languages.hasOwnProperty(i)) {
              vm.group.items[indexItem].first_layers[indexFirstLayer].second_layers[indexSecondLayer].name[vm.$store.getters.languages[i]] = secondLayer.name[vm.$store.getters.languages[i]]
            }
          }
          vm.group.items[indexItem].first_layers[indexFirstLayer].second_layers[indexSecondLayer].sku = secondLayer.sku
          vm.group.items[indexItem].first_layers[indexFirstLayer].second_layers[indexSecondLayer].second_id = secondLayer.id
          vm.group.items[indexItem].first_layers[indexFirstLayer].second_layers[indexSecondLayer].short_name = secondLayer.short_name
        }
      },
      addPriceToSingleSecond(itemIndex, firstIndex, secondIindex) {
        let prices = {}
        let price_without_tax = {}
        for (let t in vm.tier) {
          prices[t] = 0,
          price_without_tax[t] = 0
        }
        vm.group.items[itemIndex].first_layers[firstIndex].second_layers[secondIindex].prices.push({
          from: defaultDateFrom,
          to: defaultDateTo,
          price: prices,
          price_without_tax: price_without_tax,
          tax_rate: 0,
          active: 1
        })
      },
      removePriceToSingleSecond(itemIndex, firstIndex, secondIndex, priceIndex) {
        let prices = []
        for (let i in vm.group.items[itemIndex].first_layers[firstIndex].second_layers[secondIndex].prices) {
          if (i != priceIndex) {
            prices.push(vm.group.items[itemIndex].first_layers[firstIndex].second_layers[secondIndex].prices[i])
          }
        }
        vm.group.items[itemIndex].first_layers[firstIndex].second_layers[secondIndex].prices = prices
      },
      hideModal(el) {
        this.$root.$emit('bv::hide::modal', el)
      },
      showModal(el) {
        this.$root.$emit('bv::show::modal', el)
      },
      updateGroupItemShow(event, i) {
        vm.groupItemShow[i] = !vm.groupItemShow[i]
        this.$forceUpdate('groupItemShow[' + i + ']')
      },
      finishCreateComboGroup() {
        this.$bus.$emit('loading', 'block')
        let deleteGroups = vm._.cloneDeep(vm.deleteGroups)
        for (let i in deleteGroups) {
          vm.axios.menu.deleteComboGroup(deleteGroups[i], function (response) {
          })
        }
        vm.deleteGroups = []
        if (vm.itemDefault && vm.itemDefault.first_layers && vm.itemDefault.first_layers.length > 0) {
          if ((vm.objDefault.single && !vm.objDefault.first)) {
            vm.$toastr.error(vm.$t('message.please_set_default'), '', {})
            vm.$bus.$emit('loading', 'none')
            return
          }

          for (let indexFirst = 0; indexFirst < vm.itemDefault.first_layers.length; indexFirst++) {
            const firstLayer = vm.itemDefault.first_layers[indexFirst];
            if (!firstLayer.default) continue
            if ((firstLayer.second_layers && firstLayer.second_layers.length > 0) && (vm.objDefault.first && !vm.objDefault.second)) {
              vm.$toastr.error(vm.$t('message.please_set_default'), '', {})
              vm.$bus.$emit('loading', 'none')
              return
            }
          }
        }
        
        this.saveComboGroup(function (uuid) {
          vm.moveToNewGroup(uuid)
        })
      },
      saveComboGroup(cb) {
        vm.$bus.$emit('loading', 'block')
        vm.group.items = vm.group.items.filter(i => i.single_id)

        for (let indexItem = 0; indexItem < vm.group.items.length; indexItem++) {
          vm.group.items[indexItem].first_layers = vm.group.items[indexItem].first_layers.filter(first => first.sku !== '')

          for (let firstIndex = 0; firstIndex < vm.group.items[indexItem].first_layers.length; firstIndex++) {
            vm.group.items[indexItem].first_layers[firstIndex].second_layers = vm.group.items[indexItem].first_layers[firstIndex].second_layers.filter(second => second.sku)
          }
        }

        let checkItemDefault = false
        let checkSizeDefault = false
        let checkCustDefault = false

        for (let itemIndex = 0; itemIndex < vm.group.items.length; itemIndex++) {
          if (!vm.group.items[itemIndex].default) continue
          if (!vm.combo.config.set_default) {
            vm.group.items[itemIndex].default = 0
          }
          checkItemDefault = true
          // bypass for case haven't size and crust
          if (vm.group.items[itemIndex].first_layers.length <= 0) {
            checkSizeDefault = true
            checkCustDefault = true
            continue
          }
          //--------------
          for (let firstIndex = 0; firstIndex < vm.group.items[itemIndex].first_layers.length; firstIndex++) {
            if (!vm.group.items[itemIndex].first_layers[firstIndex].default) continue
            if (!vm.combo.config.set_default) {
              vm.group.items[itemIndex].first_layers[firstIndex].default = 0
            }
            checkSizeDefault = true
            // bypass for case haven't crust
            if (vm.group.items[itemIndex].first_layers[firstIndex].second_layers.length <= 0) {
              checkCustDefault = true
              continue
            }
            //---------
            for (let secondIndex = 0; secondIndex < vm.group.items[itemIndex].first_layers[firstIndex].second_layers.length; secondIndex++) {
              if (!vm.group.items[itemIndex].first_layers[firstIndex].second_layers[secondIndex].default) continue
              if (!vm.combo.config.set_default) {
                vm.group.items[itemIndex].first_layers[firstIndex].second_layers[secondIndex].default = 0
              }
              checkCustDefault = true
              
            }
          }
        }

        // set sequence
        vm.group.items.map((item,indexItem) => {
          item.sequence = indexItem;
          return item.first_layers.map((first,indexFirst) => {
            first.sequence = indexFirst;
            return first.second_layers.map((second,indexSecond) => {
              second.sequence = indexSecond
              return second;
            })
          })
        })
        
        if ( vm.combo.config.set_default && ((checkItemDefault && !checkSizeDefault) || (checkItemDefault && checkSizeDefault && !checkCustDefault)) ) {
          vm.$toastr.error(vm.$t('message.please_set_default'), '', {})
          vm.$bus.$emit('loading', 'none')
          return
        }

        let item = JSON.parse(JSON.stringify(vm.group))
        if (item.items.length === 0) {
          vm.$toastr.error(vm.$t('message.combo_detail_no_item'), vm.$t('message.error'), {})
          vm.$bus.$emit('loading', 'none')
          return
        }
        let formData = new FormData()
        let oldUrl = []
        for (let i in vm.group.image) {
          if (vm.group.image[i] && vm.group.image[i].type != undefined) {
            formData.append(i, vm.group.image[i])
          } else {
            oldUrl[i] = vm.group.image[i]
          }
        }
        let config = {'Content-Type': 'multipart/form-data'}
        item.min = parseInt(item.min, 10)
        item.max = parseInt(item.max, 10)
        let newItem = item
        // call an API to save imag
        vm.axios.menu.uploadComboImages(formData, config, function (response) {
          if (response.data.status == true) {
            for (let i in response.data.data.item) {
              newItem.image[i] = response.data.data.item[i]
            }
            // get old url
            for (let i in oldUrl) {
              newItem.image[i] = oldUrl[i]
            }
            // get opening times
            for (let i in vm.group.items) {
              newItem.items[i].opening_times = []
              for (let j in vm.group.items[i].opening_times) {
                newItem.items[i].opening_times.push(vm.group.items[i].opening_times[j])
              }
            }
            for (let j = 0; j < vm.group.items.length; j++) {
              // change date for prices
              let prices = []
              for (let k = 0; k < vm.group.items[j].prices.length; k++) {
                prices.push({
                  'from': vm.group.items[j].prices[k].from.substring(0, 10) + ' 00:00:00',
                  'to': vm.group.items[j].prices[k].to.substring(0, 10) + ' 23:59:59',
                  'price': vm.group.items[j].prices[k].price,
                  'price_without_tax': vm.group.items[j].prices[k].price_without_tax,
                  'tax_rate': vm.group.items[j].prices[k].tax_rate
                })
              }
              newItem.items[j].prices = prices

              // change date for special prices
              // let special_dates = []
              // for (let k = 0; k < vm.item.groups[group_index].items[j].special_dates.length; k++) {
              //   special_dates.push({
              //     'date': vm.revertDateFormat(vm.item.groups[group_index].items[j].special_dates[k].date),
              //     'active': vm.item.groups[group_index].items[j].special_dates[k].active,
              //     'from': vm.item.groups[group_index].items[j].special_dates[k].from,
              //     'name': vm.item.groups[group_index].items[j].special_dates[k].name,
              //     'status': vm.item.groups[group_index].items[j].special_dates[k].status,
              //     'to': vm.item.groups[group_index].items[j].special_dates[k].to
              //   })
              // }
              // newItem[i][j].special_dates = special_dates

              // change date for first layer
              let first_layers = vm.group.items[j].first_layers
              for (let k in first_layers) {
                // prices for first layers
                let prices = []
                for (let l in first_layers[k].prices) {
                  prices.push({
                    'from': first_layers[k].prices[l].from.substring(0, 10) + ' 00:00:00',
                    'to': first_layers[k].prices[l].to.substring(0, 10) + ' 23:59:59',
                    'price': first_layers[k].prices[l].price,
                    'price_without_tax': first_layers[k].prices[l].price_without_tax,
                    'tax_rate': first_layers[k].prices[l].tax_rate,
                    'active': first_layers[k].prices[l].active
                  })
                }
                newItem.items[j].first_layers[k].prices = prices

                // prices for second layers
                let second_layers = first_layers[k].second_layers
                for (let l in second_layers) {
                  let pricesSeconds = []
                  for (let m in second_layers[l].prices) {
                    pricesSeconds.push({
                      'from': second_layers[l].prices[m].from.substring(0, 10) + ' 00:00:00',
                      'to': second_layers[l].prices[m].to.substring(0, 10) + ' 23:59:59',
                      'price': second_layers[l].prices[m].price,
                      'price_without_tax': second_layers[l].prices[m].price_without_tax,
                      'tax_rate': second_layers[l].prices[m].tax_rate,
                      'active': second_layers[l].prices[m].active
                    })
                  }
                  newItem.items[j].first_layers[k].second_layers[l].prices = pricesSeconds
                }
              }
            }

            newItem['combo_id'] = vm.item.combo_id
            // call an API to save combo group information
            // check create or update
            if (newItem.newGroup == 1) {
              vm.axios.menu.createComboGroup(newItem, function (response) {
                // update uuid for group
                for (let g in vm.item.groups) {
                  if (vm.item.groups[g].uuid == vm.group.uuid) {
                    vm.item.groups[g] = vm._.cloneDeep(vm.group)
                    vm.item.groups[g].uuid = response.data.data.item.uuid
                    vm.item.groups[g].newGroup = 0
                    break
                  }
                }

                vm.group.uuid = response.data.data.item.uuid
                vm.group.newGroup = 0
                vm.resetGroup()
                vm.groupValue = vm._.cloneDeep(vm.group)
                // vm.moveToNewGroup(vm.group.uuid)
                vm.$bus.$emit('loading', 'none')
                vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
                cb(vm.group.uuid)
              }, function (error) {
                vm.$bus.$emit('loading', 'none')
                vm.$toastr.error(vm.$t('combo.group') + ' ' + vm.group.name[vm.$session.get('lang')] + ' ' + vm.$t('message.update_fail'), vm.$t('message.error'), {})
                cb(vm.group.uuid)
              })
            } else {
              vm.axios.menu.updateComboGroup(newItem, function (response) {
                for (let l in vm.menuItemSelected) {
                  if (typeof vm.menuItemSelected[l].text !== "undefined") {
                    vm.menuItemSelected[l] = vm.menuItemSelected[l].value
                  }
                }
                vm.group.newGroup = 0
                for (let g in vm.item.groups) {
                  if (vm.item.groups[g].uuid == vm.group.uuid) {
                    vm.item.groups[g] = vm._.cloneDeep(vm.group)
                    break
                  }
                }
                vm.resetGroup()
                vm.groupValue = vm._.cloneDeep(vm.group)
                vm.$bus.$emit('loading', 'none')
                vm.$toastr.success(vm.$t('message.update_successful'), vm.$t('message.success'), {})
                cb(vm.group.uuid)
              }, function (error) {
                vm.$bus.$emit('loading', 'none')
                vm.$toastr.error(vm.$t('combo.group') + ' ' + vm.group.name[vm.$session.get('lang')] + ' ' + vm.$t('message.update_fail'), vm.$t('message.error'), {})
                cb(vm.group.uuid)
              })
            }
          }
        }, function (response) {
          vm.$bus.$emit('loading', 'none')
        })
      },
      removeGroup() {
        vm.deleteGroups.push(vm.group.uuid)
        let groups = []
        for (let i in vm.item.groups) {
          if (vm.item.groups[i].uuid != vm.group.uuid) {
            groups.push(vm.item.groups[i])
          }
        }
        vm.item.groups = groups
        if (vm.item.groups.length > 0) {
          vm.active_group_uuid = vm.item.groups[0].uuid
          vm.group = vm.item.groups[0]
          vm.resetGroup()
        }
      },
      addItem() {

        for (let i = 0 ; i < this.quantityMenuItem *1; i++){

          let items = vm.group.items
          let days = {}
          for (let i in vm.daysOfWeek) {
            days[vm.daysOfWeek[i]] = {
              day: vm.daysOfWeek[i],
              opening: '08:00:00',
              closing: '23:00:00',
              active: 1
            }
          }

          vm.group.items.push({
            single_id: '',
            opening_times: days,
            special_dates: [],
            prices: [],
            first_layers: []
          })

          vm.menuItemSelected[items.length - 1] = ''
          vm.groupItemShow[items.length - 1] = false

        }
      },
      addSingleFirst (i) {
        let price = {}
        let price_without_tax = {}
        let prices = []
        for (let t in vm.tier) {
          price[t] = 0,
          price_without_tax[t]
        }
        prices.push({
          from: defaultDateFrom,
          to: defaultDateTo,
          price: price,
          price_without_tax: price_without_tax,
          tax_rate: 0,
          active: 1
        })

        let lang = {}
        for (let l in this.$store.getters.languages) {
          lang[this.$store.getters.languages[l]] = ''
        }
        vm.group.items[i].first_layers.push({
          name: lang,
          prices: prices,
          special_dates: [],
          opening_times: [],
          second_layers: [],
          sku: '',
          image: {},
          active: 1
        })

        // enable save group button
        // vm.addNew = true
      },
      addComboGroup () {
        // prepare data for image
        let uuid = vm.item.groups.length
        let data = {}
        for (let i in vm.images) {
          data[vm.images[i]] = ''
        }
        let name = {}
        for (let l in this.$store.getters.languages) {
          name[this.$store.getters.languages[l]] = 'Group ' + uuid
        }
        vm.item.groups.push({
          name: name,
          uuid: uuid,
          sequence: 0,
          min: 1,
          max: 1,
          image: {},
          imageData: data,
          active: 1,
          menuItemSelected: [],
          items: [],
          priceStatus: [],
          newGroup: 1
        })
        vm.updateActiveGroupUuid(uuid)
      },
      deleteComboGroups () {
        let options = {
          html: true,
          okText: vm.$t('common.delete'),
          cancelText: vm.$t('common.cancel')
        }
        vm.$dialog.confirm(vm.$t('message.delete_confirm'), options)
          .then(function (dialog) {
            vm.$bus.$emit('loading', 'block')
            let deleteGroups = vm._.cloneDeep(vm.deleteGroups)
            let exist = false
            if(deleteGroups.indexOf(vm.group.uuid) >= 0) {
              exist = true
            }
            for (let i in deleteGroups) {
              vm.axios.menu.deleteComboGroup(deleteGroups[i], function (response) {
                for (let j in vm.item.groups) {
                  if (deleteGroups[i] == vm.item.groups[j].uuid) {
                    vm.item.groups.splice(j, 1)
                  } else {
                    if (exist) {
                      vm.updateActiveGroupUuid(vm.item.groups[j].uuid)
                    }
                  }
                }
              })
            }
            vm.deleteGroups = []
            vm.$bus.$emit('loading', 'none')
          })
          .catch(function () {
          })
      },
      cloneComboGroup () {
        // prepare data for image
        let uuid = vm.item.groups.length
        let data = {}
        for (let i in vm.images) {
          data[vm.images[i]] = ''
        }
        let group = vm._.cloneDeep(vm.group)
        group.uuid = uuid
        group.newGroup = 1
        vm.item.groups.push(group)

        vm.updateActiveGroupUuid(uuid)
      }
    },
    created: function () {
      vm = this
      let langs = vm.$store.getters.languages
      for (let l in langs) {
        let lang = langs[l]
        vm.menuItems[lang] = []
      }
      vm.getFirstLayerOptions()
      vm.getSecondLayerOptions()
      vm.getMenuList()
    },
    mounted: function () {
      // prepare data for image
      let data = {}
      for (let i in vm.images) {
        data[vm.images[i]] = ''
      }

      let priceDefault = {}
      for (let t in vm.tier) {
        priceDefault[t] = 0
      }
      vm.imageData = data

      vm.axios.menu.getComboDetail(vm.uuid, function (response) {
        vm.item.combo_id = response.data.data.item.id
        vm.item.combo_uuid = response.data.data.item.uuid

        vm.item.groups = response.data.data.item.groups

        if (vm.item.groups.length > 0) {
          vm.active_group_uuid = vm.item.groups[0].uuid
          vm.group = vm._.cloneDeep(vm.item.groups[0])
          for (let i = 0; i < vm.group.items.length; i++) {
            if (!vm.group.items[i].default) continue
            vm.objDefault.single = true
            for (let firstIndex = 0; firstIndex < vm.group.items[i].first_layers.length; firstIndex++) {
              if (!vm.group.items[i].first_layers[firstIndex].default) continue
              vm.objDefault.first = true
              for (let secondIndex = 0; secondIndex < vm.group.items[i].first_layers[firstIndex].second_layers.length; secondIndex++) {
                if (!vm.group.items[i].first_layers[firstIndex].second_layers[secondIndex].default) continue
                vm.objDefault.second = true
              }
            }
            
          }
          vm.group.items = vm.sortData()
          vm.resetGroup()
          vm.groupValue = vm._.cloneDeep(vm.group)
        } else {
          vm.addComboGroup()
        }
      })
    },
  }
</script>

<style scoped>
  .group-header {
    width: 100%;
    margin-bottom: 1rem;
    border: 0;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }

  .list-item-first-second {
    max-width: 100%;
    cursor: move;
  }

  .ghost {
    opacity: 0.5;
  }

  .list-item {
    cursor: move;
  }
  .list-item-first {
    cursor: move;
  }

  .no-input-button {
    flex: inherit;
    width: 45px;
  }

  .mr-r-default-first {
    margin-right: 10px;
  }
  .switch-customize {
    height: 24px !important;
    border: none;
    background-color: transparent !important;
    margin-bottom: 0px;
  }
  .br-color-default {
    background-color: #e7a6a6;
  }

  .group-header .group-item {
    display: inline-block;
    height: 48px;
    border: 1px solid #979797;
    -webkit-box-flex: 0;
    -ms-flex: 0 0 auto;
    flex: 0 0 auto;
    width: auto;
    max-width: none;
    cursor: pointer;
    line-height: 43px;
    font-weight: 600;
    padding-left: 5px;
    padding-right: 5px;
    margin-right: 5px;
    border-radius: 4px;
  }

  .group-header .group-item.active {
    color: #fff;
    border: 1px solid #5b5e62;
    background-color: #5b5e62;
  }

  .group-header .group-checkbox {
    float: left;
    padding-top: 7px;
  }
  .group-header .group-checkbox .custom-checkbox {
    margin-right: 5px !important;
  }

  .group-header .group-name {
    float: left;
  }

  .group-body {
    margin-top: 10px;

  }

  .menu-item-content {
    width: 100%;
    margin-left: -5px;
    margin-top: -5px;
  }

  .menu-item-content .card-header {
    background: #5c5e63 !important;
    color: #fff;
  }

  .menu-item-content .card-body {
    padding: 10px;
  }

  .menu-item-ddl {
    margin-bottom: 10px;
  }

  .menu-item-ddl label:last-child {
    background: #fff;
    line-height: 35px;
    color: #5b5e62 !important;
    height: 35px;
    width: 50px;
    text-align: center;
    font-size: 20px;
    border-radius: 5px;
  }

  .remove-section {
    line-height: 35px;
    cursor: pointer;
  }

  .fa.fa-files-o, .fa.fa-trash-o {
    font-size: 30px;
    line-height: 35px;
  }

  .option-box {
    padding-bottom: 15px;
  }

  .option-first {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    background: #e1e6eb;
    padding: 20px;
  }

  .option-first input:disabled {
    background-color: #cccccc !important;
  }

  .size-label {
    min-width: 50px;
    width: auto;
    padding-right: 10px;
    height: 35px;
    line-height: 35px;
    font-weight: 600;
  }

  .mr-default {
    margin-top: 2px;
  }

  .size-name-input {
    flex: 1;
    padding-left: 5px;
    padding-right: 5px;
  }

  .size-code-input {
    flex: 1;
    padding-left: 5px;
    padding-right: 5px;
  }

  .size-price-input {
    flex: 1;
    padding-left: 5px;
    padding-right: 5px;
  }

  .size-active {
    padding-top: 5px;
    text-align: center;
  }

  .size-remove {
    text-align: center;
    font-size: 20px;
    line-height: 35px;
    cursor: pointer;
  }

  .option-second {
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    background: #f5f7f9;
    padding: 20px 15px 0 15px;
  }

  .second-box {
    background: #fff;
    border-radius: 4px;
    border: 1px solid #ccc;
    padding: 15px;
    margin-bottom: 15px;
  }

  .second-header {
    line-height: 0px;
  }

  .second-box .second-header .close-btn {
    float: right;
    cursor: pointer;
  }

  .combo-form .card-footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 7.75px;
    border-top: none;
    margin-top: 1.5rem;
    z-index: 999;
  }

  .combo-form .btn-save {
    float: right;
    margin-right: 22px;
  }

  .back-button {
    padding-left: 25px;
    width: 95px;
    float: left;
  }

  .btn-save {
    float: right;
    padding-right: 22px;
    margin-right: 0px !important;
    box-sizing: border-box;
    text-align: right;
  }
</style>
<style>
  /*.item[data-vss-custom-attr="selling-attr"] {*/
  /*color: red !important;*/
  /*}*/
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
  .multiselect__option--highlight {
    background: #1DE9B6 !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/admin/combo/GroupForm.vue